import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteRapport, BokkzAlgDataService, IncomeTaxEntity, OpbouwOverigePGA,
  SpecificatieOverigePGA
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-overige-pga',
  templateUrl: './spec-overige-pga.component.html',
  styleUrls: ['./spec-overige-pga.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class SpecOverigePgaComponent implements OnInit {
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);

    specOverigePGAFormGroup = this.fb.group<AangifteRapport>({});
    specOverigePGA = {} as AangifteRapport;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specOverigePGAFormGroup = this.fb.group<AangifteRapport>(({
            specificatieOverigePGA: this.fb.group<SpecificatieOverigePGA>(({
                opbouw: this.fb.group<OpbouwOverigePGA>(({
                    aftrekPerVerzorgingsdagWeekenduitgaven: null as unknown as number,
                    aftrekReiskostenWeekenduitgaven: null as unknown as number,
                    vergoedingWeekenduitgaven: null as unknown as number,
                    totaalAftrekbareWeekenduitgaven: null as unknown as number,
                    totaleWeekenduitgaven: null as unknown as number,
                    aandeelWeekenduitgaven: null as unknown as number,
                    totaalAftrekbareAlimentatie: null as unknown as number,
                    aandeelAftrekbareAlimentatie: null as unknown as number,
                    totaalRestantPga: null as unknown as number,
                    aandeelRestantPga: null as unknown as number,
                    nietToegerekendePga: null as unknown as number,
                } as OpbouwOverigePGA))
            } as SpecificatieOverigePGA))
        } as AangifteRapport))
    }

    propertyNamesToCheck: string[] = [
        'aftrekPerVerzorgingsdagWeekenduitgaven',
        'aftrekReiskostenWeekenduitgaven',
        'vergoedingWeekenduitgaven',
        'totaalAftrekbareWeekenduitgaven',
        'totaleWeekenduitgaven',
        'aandeelWeekenduitgaven',
        'totaalAftrekbareAlimentatie',
        'aandeelAftrekbareAlimentatie',
        'totaalRestantPga',
        'aandeelRestantPga',
        'nietToegerekendePga',
    ];

    propertyTextMap: Record<string, string> = {
        aftrekPerVerzorgingsdagWeekenduitgaven: 'Aftrek per verzorgingsdag weekenduitgaven',
        aftrekReiskostenWeekenduitgaven: 'Aftrek reiskosten weekenduitgaven',
        vergoedingWeekenduitgaven: 'Vergoeding weekenduitgaven',
        totaalAftrekbareWeekenduitgaven: 'Totaal aftrekbare weekenduitgaven',
        totaleWeekenduitgaven: 'Aftrek voor tijdelijk verblijf thuis van ernstig gehandicapten',
        aandeelWeekenduitgaven: 'Aftrek voor tijdelijk verblijf thuis van ernstig gehandicapten',
        totaalAftrekbareAlimentatie: 'Totaal aftrekbare alimentatie',
        aandeelAftrekbareAlimentatie: 'Onderhoudsverplichtingen',
        totaalRestantPga: 'Totaal restant persoongsbenonden aftrek',
        aandeelRestantPga: 'Restant persoonsgebonden aftrek voorgaande jaren',
        nietToegerekendePga: 'Niet toegerekende pga',
    };

    getPropertyValue(propertyName: string): number | null {
        const control = this.specOverigePGAFormGroup.get(['specificatieOverigePGA', 'opbouw', propertyName]);
        return control ? control.value : null;
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specOverigePGA = value;
                    this.specOverigePGAFormGroup.patchValue(this.specOverigePGA)
                });
            }
        });
    }

    protected readonly Object = Object;
}
